import CustomTable from "components/CustomTable";
import { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faFileInvoice,
  faMoneyBillWave,
  faPercent,
  faCalendarAlt,
  faBuildingColumns,
  faCoins,
  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";
import {
  useUpdateCommissionBatchByIdMutation,
  useGetCommissionBatchByIdQuery,
} from "features/SaathiManagement/Commision/CommissionApiSlice";
import { Link, useParams } from "react-router-dom";
import CardHeader from "react-bootstrap/esm/CardHeader";
import CustomSearchBar from "components/CustomSearchBar";
import { store } from "app/store";
import { API_URL } from "app/config";
import { Modal, Spinner } from "react-bootstrap";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Divider,
} from "@mui/material";
import { Save } from "@mui/icons-material";
import { toast } from "react-toastify";
const BankingInvoiceDetailView = () => {
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [batchInfo, setBatchInfo] = useState({});
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const {
    data,
    isLoading,
    isFetching,
    refetch,
  } = useGetCommissionBatchByIdQuery(id);
  const [loading, setLoading] = useState(false);
  const [statusUpdate, setstatusUpdate] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [status, setStatus] = useState("");
  const [updateStatus] = useUpdateCommissionBatchByIdMutation();
  const [loadingStatus, setLoadingStatus] = useState(false);
  useEffect(() => {
    const dataFromApi = data?.data?.applications || [];
    const batchData = data?.data?.batch_info || {};
    const paginationFromApi = data?.pagination
      ? {
          page: data.pagination.page,
          pageCount: data.pagination.total_pages,
          per_page: data.pagination.per_page,
          total: data.pagination.total,
        }
      : pagination;

    setUsers(dataFromApi);
    setBatchInfo(batchData);
    setPagination(paginationFromApi);
  }, [data]);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 70,
      sortable: false,
      renderCell: ({ row }) => (
        <Link to={`/banking/applications/${row.application_id}`}>
          <FontAwesomeIcon icon={faEye} className="mx-2 text-warning" />
        </Link>
      ),
    },
    {
      field: "application_id",
      headerName: "Application ID",
      width: 200,
      renderCell: ({ value }) => (
        <strong style={{ fontSize: "13px", color: "#555252" }}>{value}</strong>
      ),
    },
    {
      field: "customer_name",
      headerName: "Customer Name",
      width: 180,
      renderCell: ({ value }) => <span>{value}</span>,
    },
    {
      field: "branch_name",
      headerName: "Branch",
      width: 160,
    },
    {
      field: "loan_account_no",
      headerName: "Loan A/C No",
      width: 150,
    },
    {
      field: "loan_sanctioned_at",
      headerName: "Sanction Date",
      width: 140,
      renderCell: ({ value }) =>
        value ? new Date(value).toLocaleDateString("en-IN") : "-",
    },
    {
      field: "loan_amount_sanctioned",
      headerName: "Sanctioned Amt (₹)",
      width: 170,
      renderCell: ({ value }) => (
        <span style={{ color: "#555252", fontWeight: "800" }}>
          ₹ {value?.toLocaleString("en-IN")}
        </span>
      ),
    },
    {
      field: "commission_amount",
      headerName: "Commission (₹)",
      width: 160,
      renderCell: ({ value }) => (
        <span className="text-success fw-bold">
          ₹ {value?.toLocaleString("en-IN")}
        </span>
      ),
    },
    {
      field: "commission_amount_with_gst",
      headerName: "Commission inc. (GST) (₹)",
      width: 180,
      renderCell: ({ value }) => (
        <span className="text-success fw-bold">
          ₹ {value?.toLocaleString("en-IN")}
        </span>
      ),
    },
    {
      field: "gst_amount",
      headerName: "GST (₹)",
      width: 130,
      renderCell: ({ value }) => `₹ ${value?.toLocaleString("en-IN")}`,
    },
    {
      field: "cgst_amount",
      headerName: "CGST (₹)",
      width: 120,
      renderCell: ({ value }) => `₹ ${value?.toLocaleString("en-IN")}`,
    },
    {
      field: "sgst_amount",
      headerName: "SGST (₹)",
      width: 120,
      renderCell: ({ value }) => `₹ ${value?.toLocaleString("en-IN")}`,
    },
    // {
    //   field: "total_amount_with_gst",
    //   headerName: "Total (₹)",
    //   width: 150,
    //   renderCell: ({ value }) => (
    //     <strong>₹ {value?.toLocaleString("en-IN")}</strong>
    //   ),
    // },
  ];

  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading || isFetching,
    checkboxShowFalse: true,
  };

  const batchFields = [
    {
      label: "Bank Name",
      value: batchInfo.bank_name,
      icon: faBuildingColumns,
      color: "#4F46E5",
    },
    {
      label: "Bill No",
      value: batchInfo.bill_no,
      icon: faFileInvoice,
      color: "#F59E0B",
    },
    {
      label: "Month / Year",
      value: `${batchInfo.month} ${batchInfo.year}`,
      icon: faCalendarAlt,
      color: "#10B981",
    },

    {
      label: "Sanctioned Amount",
      value: `₹ ${batchInfo.loan_amount_sanctioned?.toLocaleString("en-IN")}`,
      icon: faMoneyBillWave,
      color: "#F59E0B",
    },
    {
      label: "Commission %",
      value: `${batchInfo.commission_percent}%`,
      icon: faPercent,
      color: "#F472B6",
    },
    {
      label: "Commission Amount",
      value: `₹ ${batchInfo.total_commission_amount?.toLocaleString("en-IN")}`,
      icon: faMoneyBillWave,
      color: "#3B82F6",
    },
    {
      label: "Commission Amount inc. (GST)",
      value: `₹ ${batchInfo.total_commission_amount_with_gst?.toLocaleString(
        "en-IN"
      )}`,
      icon: faCoins,
      color: "#EF4444",
    },
    {
      label: "GST %",
      value: `${batchInfo.gst_percent}%`,
      icon: faPercent,
      color: "#22D3EE",
    },
  ];

  const handleSubmission = () => {
    setLoadingStatus(true);
    let formData = new FormData();
    formData.append("status", status);
    formData.append("remarks", remarks);

    updateStatus({ id, formData })
      .unwrap()
      .then((data) => {
        toast.success("Status Uploaded Successfully !!");
        console.log(data);
        setLoadingStatus(false);
        setstatusUpdate(false);
        refetch();
      })
      .catch((err) => {
        toast.error("Error while Uploading. We will get back soon !!");
        setLoadingStatus(false);
      });
  };

  return (
    <div>
      <Row className="g-3 mb-4">
        {/* {batchFields.map((field, idx) => (
          <Col key={idx} md={6} lg={3}>
            <Card
              className="rounded-3 p-3 position-relative mb-0"
              style={{
                height: "80px",
                overflow: "hidden",
                backgroundColor: "#fff",
                borderLeft: `4px solid ${field.color}60`,
              }}
            >
              <div
                className="position-absolute d-flex justify-content-center align-items-center"
                style={{
                  width: "75px",
                  height: "75px",
                  borderRadius: "50%",
                  background: `linear-gradient(135deg, ${field.color}20, ${field.color}40)`,
                  top: "-10px",
                  right: "-10px",
                }}
              >
                <FontAwesomeIcon
                  icon={field.icon}
                  size="lg"
                  style={{ color: field.color }}
                />
              </div>

              <div className="mt-1 ms-1">
                <div className="small text-muted">{field.label}</div>
                <div
                  className="fw-bold mt-1"
                  style={{ fontSize: "0.95rem", color: "#555252" }}
                >
                  {field.value || "-"}
                </div>
              </div>
            </Card>
          </Col>
        ))} */}
        {batchFields.map((field, idx) => {
          const isMonthCard = field.label === "Month / Year";

          return (
            <Col key={idx} md={6} lg={3}>
              <Card
                className="rounded-3 p-3 position-relative mb-0"
                style={{
                  height: "80px",
                  overflow: "hidden",
                  backgroundColor: "#fff",
                  borderLeft: `4px solid ${field.color}60`,
                }}
              >
                <div
                  className="position-absolute d-flex justify-content-center align-items-center"
                  style={{
                    width: "75px",
                    height: "75px",
                    borderRadius: "50%",
                    background: `linear-gradient(135deg, ${field.color}20, ${field.color}40)`,
                    top: "-10px",
                    right: "-10px",
                  }}
                >
                  <FontAwesomeIcon
                    icon={field.icon}
                    size="lg"
                    style={{ color: field.color }}
                  />
                </div>

                <div className="mt-1 ms-1 d-flex justify-content-between align-items-start">
                  <div>
                    <div className="small text-muted">{field.label}</div>
                    <div
                      className="fw-bold mt-1"
                      style={{ fontSize: "0.95rem", color: "#555252" }}
                    >
                      {field.value || "-"}
                    </div>
                  </div>

                  {(isMonthCard && batchInfo?.status) && (
                   
                     <div >
                    <div className="small text-muted" style={{marginRight:"50px"}}>Status</div>
                    <div
                    
                    >
                        <span
                      className={`badge ${
                        batchInfo?.status === "Payment Completed"
                          ? "bg-success mx-2"
                          : "bg-warning text-dark"
                      }`}
                      style={{
                        whiteSpace: "nowrap",
                        borderRadius: "5px",
                        marginRight:"50px"
                      }}
                    >
                     {batchInfo?.status}
                    </span>
                    </div>
                  </div>
                  )}
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>

      <Card>
        <CardHeader>
          <Row className="d-flex w-100 align-items-center mt-1">
            <Col md="4">
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CustomSearchBar />
                <span className="fw-semibold text-success mx-4">
                  Total : {users?.length || 0}
                </span>
              </div>
            </Col>

            <Col
              md="6"
              lg="4"
              className="d-flex justify-content-end gap-2 offset-md-4"
            >
              <Button
                id="AddLeads"
                className="buttonOrangeDefaultColor p-2"
                size="sm"
                onClick={() => setstatusUpdate(true)}
              >
                Update Status
                &nbsp;<i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
              </Button>
              <Button
                id="AddLeads"
                className="buttonGreenDefaultColor"
                size="sm"
                onClick={() => {
                  const state = store.getState();
                  setLoading(true);

                  fetch(
                    `${API_URL}/api/v1/banking/commission-batch/${id}?report=True`,
                    {
                      headers: {
                        authorization: `Bearer ${state.auth.accessToken}`,
                      },
                    }
                  )
                    .then((res) => res.json())
                    .then((data) => {
                      if (data?.success && data?.data?.s3_path) {
                        const link = document.createElement("a");
                        link.href = data.data.s3_path;
                        link.download = "";
                        link.rel = "noopener noreferrer";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }
                    })
                    .catch((err) => {
                      console.error("Download error:", err);
                    })
                    .finally(() => {
                      setLoading(false);
                    });
                }}
              >
                Download Report
                <i className="mdi mdi-download custom-btn-fs fs-6 mx-1"></i>{" "}
                &nbsp; {loading && <Spinner size="sm" />}
              </Button>
              <Button
                className="bg-transparent text-black"
                style={{
                  border: "1px solid #829999",
                  color: "#343737",
                  marginTop: "0",
                }}
                size="sm"
                onClick={() => refetch()}
              >
                <FontAwesomeIcon icon={faRotateLeft} />
              </Button>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="p-2">
          <CustomTable
            rows={tableData.rows}
            columns={tableData.columns}
            paginationState={tableData.paginationState}
            loading={tableData.isLoading || tableData.isFetching}
            checkboxShowFalse={tableData.checkboxShowFalse}
            showPaginationOptions={false}
          />
        </CardBody>
      </Card>

      <Modal show={statusUpdate} onHide={() => setstatusUpdate(false)} centered>
        <Modal.Header closeButton className="px-4 py-3">
          <Modal.Title className="fw-semibold">Update Status</Modal.Title>
        </Modal.Header>

        <Divider />

        <Modal.Body className="px-4 py-3">
          <Box display="flex" flexDirection="column" gap={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Select Status</InputLabel>
              <Select
                label="Select Status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="Invoice Raised">Invoice Raised</MenuItem>
                <MenuItem value="Payment Completed">Payment Completed</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Remarks"
              multiline
              minRows={3}
              placeholder="Add remarks (optional)"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              fullWidth
            />
          </Box>
        </Modal.Body>
        <Divider />

        <Modal.Footer className="px-4 py-3">
          <Button
            id="AddLeads"
            className="buttonGreenDefaultColor"
            size="sm"
            onClick={() => handleSubmission()}
            disabled={!status}
          >
            Update &nbsp;{loadingStatus && <Spinner size="sm" />}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BankingInvoiceDetailView;
